import clsx from 'clsx';
import type { MapType } from './mapUtils';

const TYPES: { key: MapType; emoji: string; label: string; title: string }[] = [
  { key: 'street', emoji: '🗺️', label: 'Map', title: 'Google Street Map' },
  { key: 'satellite', emoji: '🛰️', label: 'Satellite', title: 'Google Satellite' },
  { key: 'hybrid', emoji: '🌍', label: 'Hybrid', title: 'Satellite + Labels' },
  { key: 'dark', emoji: '🌙', label: 'Dark', title: 'Dark Theme' },
];

/**
 * Tile-layer switch. Full labels on desktop; emoji-only 44px buttons on
 * phones so the strip fits a 320px map edge-to-edge.
 */
export default function MapTypeSelector({
  mapType,
  onChange,
}: {
  mapType: MapType;
  onChange: (t: MapType) => void;
}) {
  return (
    <div className="flex gap-1 p-1 bg-gray-900/95 border border-gray-700 rounded-lg">
      {TYPES.map((type) => (
        <button
          key={type.key}
          onClick={() => onChange(type.key)}
          title={type.title}
          aria-label={type.title}
          className={clsx(
            'rounded text-xs font-medium transition-all touch-manipulation',
            'min-h-11 min-w-11 lg:min-h-0 lg:min-w-0 px-2 lg:px-3 lg:py-1.5',
            mapType === type.key ? 'bg-blue-600 text-white' : 'text-gray-400 hover:text-white hover:bg-gray-700'
          )}
        >
          <span>{type.emoji}</span>
          <span className="hidden lg:inline"> {type.label}</span>
        </button>
      ))}
    </div>
  );
}
